import {EMenuId} from './constants';

export default {
  title: 'edna Pulse — единое окно для решения всех задач в области цифровых коммуникаций',
  navigation: {
    [EMenuId.HOME]: 'Главная',
    [EMenuId.TRIGGERS]: 'Сценарии',
    [EMenuId.BROADCASTS]: 'Рассылки',
    [EMenuId.DIALOGS]: 'Диалоги',
    [EMenuId.SUBSCRIBERS]: 'Аудитория',
    [EMenuId.CASCADES]: 'Каскады',
    [EMenuId.CHANNELS]: 'Каналы',
    [EMenuId.MESSAGE_MATCHERS]: 'Шаблоны',
    [EMenuId.ANALYTICS]: 'Аналитика',
    [EMenuId.ANALYTICS_MESSAGES]: 'Сообщения',
    [EMenuId.ANALYTICS_SUMMARY_REPORT]: 'Итоговый отчет',
    [EMenuId.ANALYTICS_MESSAGE_MATCHERS]: 'Статистика шаблонов',
    [EMenuId.PROFILE]: 'Профиль',
    [EMenuId.MY_PROFILE]: 'Мой профиль',
    [EMenuId.CLIENTS]: 'Клиенты компании',
    [EMenuId.COMPANY_LEAD_CLIENTS]: 'Лиды',
    [EMenuId.SUPPORT_CLIENTS]: 'Клиенты',
    [EMenuId.COMPANY_AGENT_CLIENTS]: 'Агенты',
    [EMenuId.COMPANY_PROFILE]: 'Профиль компании',
    [EMenuId.COMPANY_NEWS]: 'Новости компании',
    [EMenuId.HELP]: 'Помощь',
    [EMenuId.NOTIFICATIONS]: 'Журнал событий',
    [EMenuId.SIGN_OUT]: 'Выход',
    [EMenuId.INTEGRATION]: 'Интеграция',
    [EMenuId.CORRECTIONS]: 'Корректировки',
    [EMenuId.AGENT_PAYMENTS]: 'Платежи клиентов',
    [EMenuId.AGENT_CLIENTS]: 'Мои клиенты',
    [EMenuId.AGENT_PROFILE]: 'Профиль компании',
    [EMenuId.TARIFFS]: 'Каталог тарифов',
  },
};
